import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

/**
 * Language Provider component that manages language state and provides it to the app
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components to render
 */
export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('ar');
  const [i18nInstance, setI18nInstance] = useState(null);

  useEffect(() => {
    // Import i18n dynamically to ensure it's initialized
    import('../i18n/config').then(({ default: i18n }) => {
      setI18nInstance(i18n);
      const currentLang = i18n.language || 'en';
      setLang(currentLang);
      document.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
    });
  }, []);

  useEffect(() => {
    if (i18nInstance) {
      const currentLang = i18nInstance.language;
      setLang(currentLang);
      document.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
    }
  }, [i18nInstance?.language]);

  // Update lang state when i18n language changes
  useEffect(() => {
    if (i18nInstance) {
      const currentLang = i18nInstance.language;
      setLang(currentLang);
      document.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
    }
  }, [i18nInstance?.language]);

  const changeLanguage = (newLang) => {
    if (i18nInstance) {
      i18nInstance.changeLanguage(newLang);
      setLang(newLang);
    }
  };

  // const isRtl = lang === 'ar';

  let isRtl =  lang === 'ar' ;

  useEffect(()=>{
    isRtl = lang === 'ar';
  },[lang])

  const value = {
    lang,
    setLang: changeLanguage,
    isRtl,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

/**
 * Custom hook to use the language context
 * @returns {Object} Language context value containing lang, setLang, and isRtl
 */
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext; 